import React from "react";
import image from "../assets/images/coin.jpg";
import { Link } from "react-router-dom";

export default function LoanStepsSection() {
  const steps = [
    {
      number: "1",
      title: "Choose a Loan",
      description:
        "Select on a suitable loan product from our array of services.",
    },
    {
      number: "2",
      title: "Submit for Approval",
      description:
        "Send us your details and a representative will reach out to you.",
    },
    {
      number: "3",
      title: "Get Your Cash",
      description: "Receive your cash in the most convenient format.",
    },
  ];

  return (
    <section
      className="font-serif relative bg-cover bg-center py-16 px-4 overflow-hidden"
      style={{ backgroundImage: `url(${image})` }} // Replace with actual image path
    >
      {/* 🔲 Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-900/50 to-blue-900 z-0"></div>
      <div className=" text-white text-center py-12 px-4 z-10 relative">
        <h2 className="text-3xl md:text-4xl font-semibold mb-2">
          Fast & Easy Loan Application Process
        </h2>
        <p className="text-white mb-10 max-w-2xl mx-auto">
          Take the first step towards realising your dreams. Get hassle-free
          loans, so that you can live free!
        </p>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto mb-5">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-white text-gray-700 p-8 rounded-lg shadow-md flex-1"
            >
              <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 w-10 h-10 bg-amber-500 text-blue-900 rounded-full flex items-center justify-center font-bold text-lg shadow-md">
                {step.number}
              </div>
              <h3 className="mt-6 mb-2 text-lg font-semibold text-center">
                {step.title}
              </h3>
              <p className="text-center text-sm">{step.description}</p>
            </div>
          ))}
        </div>

        <Link
          to="/contact-us"
          className="bg-amber-500 hover:opacity-70 text-white font-semibold px-6 py-2 rounded shadow-md transition duration-300"
        >
          VIEW LOANS
        </Link>
      </div>
    </section>
  );
}
